"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jun 28 2018
 */

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var Site_1 = require("./Site");
/**
 * The company internal site.
 *
 * (revise model of site – remove unnecessary attributes from abstract class, such as company id or address)
 *
 * @author JMe
 * @author JMr
 */


var InternalSite =
/*#__PURE__*/
function (_Site_1$Site) {
  _inherits(InternalSite, _Site_1$Site);

  /**
   * @param id the internal id
   * @param externalId the external id of site, i.e. from source data
   * @param numericId This ID is intended for systems (e.g. Yieldigo) that need numeric IDs.
   * @param name the name of site
   * @param address Street + number, City, ZIP
   * @param companyId
   * @param type
   * @param formatId
   * @param stateFlags
   * @param refExternalId external id of similar site for learning (RFC 385, PROMO-517)
   */
  function InternalSite(id, externalId, numericId, name, address, companyId, type, formatId, stateFlags, refExternalId) {
    var _this;

    _classCallCheck(this, InternalSite);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalSite).call(this, id, externalId, address, companyId, type, formatId));
    _this.id = id;
    _this.externalId = externalId;
    _this.numericId = numericId;
    _this.name = name;
    _this.address = address;
    _this.companyId = companyId;
    _this.type = type;
    _this.formatId = formatId;
    _this.stateFlags = stateFlags;
    _this.refExternalId = refExternalId;
    return _this;
  }

  return InternalSite;
}(Site_1.Site);

exports.InternalSite = InternalSite;
/**
 * data schema
 */

InternalSite.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(InternalSite.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    numericId: builder.num('numericId'),
    name: builder.str('name'),
    address: builder.opt(builder.str('address')),
    companyId: builder.opt(builder.str('companyId')),
    type: builder.opt(builder.senum('type', Site_1.SiteType, CodebookLookupSequence_1.CodebookLookupSequence.SiteType)),
    formatId: builder.str('formatId'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    refExternalId: builder.opt(builder.str('refExternalId'))
  };
}();